import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormCheckboxGroup from '../form/FormCheckboxGroup';
import QuestionHeader from './QuestionHeader';
import { Typography } from '@material-ui/core';
import FormImagePickerGroup from '../form/FormImagePickerGroup';

const renderMessage = (minAnswers, maxAnswers) => {
  if (minAnswers && maxAnswers) {
    return `od ${minAnswers} do ${maxAnswers}`;
  }
  if (minAnswers) {
    return `co najmniej ${minAnswers}`;
  }
  if (maxAnswers) {
    return `co najwyżej ${maxAnswers}`;
  }
};

const SubmissionMultiChoice = ({ name, number, questionText, answers, readonly, isOptional, allowOwnAnswer, ownAnswerName, displayImages, surveyId, tenant, maxAnswers, minAnswers }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <Typography variant="caption" color="textSecondary" component="div">Możliwe jest zaznaczenie wielu odpowiedzi{minAnswers || maxAnswers ? ` (${renderMessage(minAnswers, maxAnswers)})` : null}</Typography>
      <div>
        <Field
          name={`${name}.selectedAnswersIds`}
          component={displayImages ? FormImagePickerGroup : FormCheckboxGroup}
          values={answers.map(answer => ({ value: answer.id, name: answer.answerText, imageUrl: answer.image ? `https://konsultacjejst.blob.core.windows.net/consultations-survey-question-uploads/${tenant}/${surveyId}/${answer.image.fileId}` : null }))}
          disabled={readonly}
          allowOwnAnswer={allowOwnAnswer}
          ownAnswerName={ownAnswerName}
          ownAnswerFieldName={`${name}.ownAnswers[0]`}
          multiChoice
        />
      </div>
    </div>
  </div>
);

SubmissionMultiChoice.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  displayImages: PropTypes.bool,
  surveyId: PropTypes.string,
  tenant: PropTypes.string,
  minAnswers: PropTypes.number,
  maxAnswers: PropTypes.number,
};

export default SubmissionMultiChoice;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionMultiChoice.js